import { Sun, Moon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTheme, useToggleTheme } from '@/store'

export function ThemeToggle({ className }: { className?: string }) {
  const theme = useTheme()
  const toggleTheme = useToggleTheme()

  return (
    <button
      onClick={toggleTheme}
      className={cn(
        'w-8 h-8 rounded-lg flex items-center justify-center',
        'text-star-muted hover:bg-cosmic-dusk hover:text-star-bright',
        'transition-colors',
        className,
      )}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {theme === 'dark' ? (
        <Sun className="w-4 h-4" />
      ) : (
        <Moon className="w-4 h-4" />
      )}
    </button>
  )
}
